import {
    COLLECTING_GAME_MODE,
    IDLE_GAME_MODE,
    ANSWERING_GAME_MODE,
    EDITING_GAME_MODE,
    RESET_GAME_ACTION,
    ENTER_COLLECTING_MODE_ACTION,
    ENTER_IDLE_MODE_ACTION,
    ENTER_ANSWERING_MODE_ACTION,
    ENTER_EDITING_MODE_ACTION,
    ENTER_GAME_COMPLETE_ACTION,
    GAME_COMPLETED_MODE,
} from '../constants';

const gameModeReducer = (state = IDLE_GAME_MODE, action) => {
    switch (action.type) {
        case ENTER_COLLECTING_MODE_ACTION:
            return COLLECTING_GAME_MODE;
        case ENTER_IDLE_MODE_ACTION:
        case RESET_GAME_ACTION:
            return IDLE_GAME_MODE;
        case ENTER_ANSWERING_MODE_ACTION:
            return ANSWERING_GAME_MODE;
        case ENTER_EDITING_MODE_ACTION:
            return EDITING_GAME_MODE;
        case ENTER_GAME_COMPLETE_ACTION:
            return GAME_COMPLETED_MODE;
        default:
            return state;
    }
};

export default gameModeReducer;
